// Отдельный файл для actions фильтров, чтобы избежать циклических импортов
import {
  setFilterAValue,
  setFilterBValue,
  setSearchValue,
  resetFiltersOnly,
  updateFilteredPublications,
  setSelectedPostFilter,
  clearSelectedPostFilter,
} from '../slices/currentTabSlice';
import { resetPagination } from '../slices/paginationSlice';

// Создаем thunk actions для обновления фильтров с автоматическим обновлением отфильтрованных публикаций
export const setFilterAValueWithUpdate = (value) => (dispatch) => {
  dispatch(clearSelectedPostFilter()); // Сбрасываем скрытый фильтр при изменении фильтра A
  dispatch(setFilterAValue(value));
  dispatch(updateFilteredPublications());
  dispatch(resetPagination()); // Сбрасываем пагинацию на страницу 1
};

export const setFilterBValueWithUpdate = (value) => (dispatch) => {
  dispatch(clearSelectedPostFilter()); // Сбрасываем скрытый фильтр при изменении фильтра B
  dispatch(setFilterBValue(value));
  dispatch(updateFilteredPublications());
  dispatch(resetPagination()); // Сбрасываем пагинацию на страницу 1
};

export const setSearchValueWithUpdate = (value) => (dispatch) => {
  dispatch(clearSelectedPostFilter()); // Сбрасываем скрытый фильтр при поиске
  dispatch(setSearchValue(value));
  dispatch(updateFilteredPublications());
  dispatch(resetPagination()); // Сбрасываем пагинацию на страницу 1
};

export const resetFiltersOnlyWithUpdate = () => (dispatch) => {
  dispatch(resetFiltersOnly());
  dispatch(updateFilteredPublications());
  dispatch(resetPagination()); // Сбрасываем пагинацию на страницу 1
};

export const setSelectedPostFilterWithUpdate = (engName) => (dispatch) => {
  dispatch(setSelectedPostFilter(engName));
  dispatch(updateFilteredPublications());
  dispatch(resetPagination()); // Сбрасываем пагинацию на страницу 1
};

export const clearSelectedPostFilterWithUpdate = () => (dispatch) => {
  dispatch(clearSelectedPostFilter());
  dispatch(updateFilteredPublications());
  dispatch(resetPagination()); // Сбрасываем пагинацию на страницу 1
};

export { setFilterAValue, setFilterBValue, setSearchValue, updateFilteredPublications };
